module.exports = __webpack_public_path__ + "img/nexteev-sem-slogan.8e337483.svg";